
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useRoutineSubscriptions = (
  profile: any,
  personalRoutines: any[],
  refetchRoutines: () => void
) => {
  useEffect(() => {
    if (!profile?.id) return;

    console.log("Setting up optimized routine subscriptions for user:", profile.id);

    const routinesChannel = supabase
      .channel(`user-routines-${profile.id}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'routines',
          filter: `user_id=eq.${profile.id}`
        },
        (payload) => {
          console.log('Routine change detected:', payload);
          refetchRoutines();
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'workout_plan_routines'
        },
        (payload) => {
          console.log('Plan routine link change detected:', payload);
          refetchRoutines();
        }
      )
      .subscribe();

    return () => {
      console.log("Cleaning up routine subscriptions");
      supabase.removeChannel(routinesChannel);
    };
  }, [profile?.id, refetchRoutines]);
};
